import type { DraftJobGuidedDetails, Maybe } from 'src/graphql/generated';

const createGuidedList = (
  id: string,
  title: string,
  guidedItems?: Maybe<DraftJobGuidedDetails>,
): string => {
  let guidedBlock = '';
  if (guidedItems && guidedItems.values && guidedItems.values.length > 0) {
    guidedBlock += `<p id=${id}><strong>${title}</strong></p>`;
    guidedBlock += `<ul aria-labelledby=${id}>`;
    guidedItems.values.map((q) => {
      guidedBlock += `<li>${q}</li>`;
    });
    guidedBlock += '</ul>';
  }

  return guidedBlock;
};

export const getCreateGuidedJobDescription =
  (
    aboutBusinessLabel: string,
    responsibilitiesLabel: string,
    qualificationsLabel: string,
    benefitsLabel: string,
  ) =>
  (guidedDetails?: Maybe<DraftJobGuidedDetails>[] | null): string => {
    let guidedJobDescription = '';

    if (!guidedDetails) return guidedJobDescription;

    const aboutBusiness = guidedDetails.find(
      (details) => details && details.type === 'ABOUT_BUSINESS',
    );
    const responsibilities = guidedDetails.find(
      (details) => details && details.type === 'RESPONSIBILITIES',
    );
    const qualifications = guidedDetails.find(
      (details) => details && details.type === 'QUALIFICATIONS',
    );
    const benefits = guidedDetails.find(
      (details) => details && details.type === 'BENEFITS',
    );

    if (aboutBusiness && aboutBusiness.values) {
      guidedJobDescription += `<p><strong>${aboutBusinessLabel}</strong></p>`;
      guidedJobDescription += `<p>${aboutBusiness.values[0]}</p>`;
    }

    guidedJobDescription += createGuidedList(
      'tasks-responsibilities',
      responsibilitiesLabel,
      responsibilities,
    );
    guidedJobDescription += createGuidedList(
      'qualifications-experience',
      qualificationsLabel,
      qualifications,
    );
    guidedJobDescription += createGuidedList(
      'benefits',
      benefitsLabel,
      benefits,
    );

    return guidedJobDescription;
  };
